<template>
  <div class="IncreaseSizeRange">
    <el-dialog
      title="添加尺寸范围"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="beforeCloseComponents"
    >
      <el-form ref="formData" :model="formData" :rules="rulesFormData" label-width="110px">
        <el-form-item label="尺寸范围名称" prop="sizeName">
          <el-row type="flex" justify="flex-start" align="middle">
            <el-input v-model="formData.sizeName" style="width: 50%;margin-right: 20px;"></el-input>
            <el-button type="primary" @click="handleIncrease" :loading="loadingIncrease">添加</el-button>
          </el-row>
        </el-form-item>
        <el-form-item label="尺寸范围" prop="sizeValue">
          <el-row type="flex" justify="flex-start" align="middle">
            <el-input v-model="formData.sizeValue" style="width: 50%;"></el-input>
            <span style="padding:0 20px;white-space: nowrap;">单位：cm</span>
          </el-row>
        </el-form-item>
      </el-form>

      <el-table :data="listTable" border size="small">
        <el-table-column prop="sizeName" align="center" label="尺寸范围名称"></el-table-column>
        <el-table-column prop="sizeValue" align="center" label="尺寸范围">
          <!-- <template slot-scope="scope">
            <span>{{ `${scope.row.smallLength}*${scope.row.smallWidth}*${scope.row.smallHeight}` }}</span>
            <span>~</span>
            <span>{{`${scope.row.bigLenght}*${scope.row.bigWidth}*${scope.row.bigHeight}`}}</span>
          </template>-->
        </el-table-column>
        <el-table-column align="center" width="200" label="操作">
          <template slot-scope="scope">
            <el-button type="danger" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { ajaxPost, Baseurl } from '@/api/api/api'

export default {
  name: 'IncreaseSizeRange',
  data() {
    return {
      dialogVisible: false,
      formData: {
        sizeName: '',
        sizeValue: ''
      },
      rulesFormData: {
        sizeName: [
          { required: true, max: 10, message: '此项为必填项且长度不能超过10', trigger: 'blur' }
        ],
        sizeValue: [
          { required: true, message: '此项为必填项', trigger: 'blur' }
        ]
      },
      listTable: [],
      loadingIncrease: false
    }
  },
  methods: {
    initComponents() {
      this.dialogVisible = true

      this.getListTable()
    },
    beforeCloseComponents(done) {
      this.loadingIncrease = false
      this.$refs.formData.resetFields()
      this.$refs.formData.clearValidate()
      done()
    },
    handleIncrease() {
      this.$refs.formData.validate((valid) => {
        if (!valid) return
        const API = Baseurl + 'logisticsConfigurationController/insertLogisticsSize'
        const paramsData = this.formData
        this.loadingIncrease = true

        ajaxPost(API, paramsData).then(res => {
          const { code } = res.data
          this.loadingIncrease = false
          if (code === 200) {
            this.$refs.formData.resetFields()
            this.$message.success('操作成功！')
            this.getListTable()
          }
        })
      })
    },
    handleDelete(row) {
      this.$confirm('确定要删除该尺寸范围数据吗？', '提示')
        .then(() => {
          const API = Baseurl + 'logisticsConfigurationController/deleteLogisticsSize'
          const paramsData = {
            id: row.id
          }

          ajaxPost(API, paramsData).then(res => {
            const { code, data } = res.data
            if (code === 200) {
              this.$message.success('操作成功！')
              this.getListTable()
            } else if (code === 500) {
              this.$message.error(data)
            } else {
              this.$message.error('操作失败！')
            }
          })
        })
    },
    getListTable() {
      const API = Baseurl + 'logisticsConfigurationController/selectLogisticsSizeList'

      ajaxPost(API).then(res => {
        const { code, data } = res.data
        if (code === 200) {
          this.listTable = data
        }
      })
    }
  }
}
</script>
